module.exports = __webpack_public_path__ + "img/success_2.75b1bedc.png";